import React from 'react'
import { Text } from 'components'
import classNames from 'classnames'
import styles from './AprraisedValue.module.scss'

const AprraisedValue = ({
  show = true,
  value,
  label,
  type = 'column',
  strike = false,
  isCampaign = false,
}) => {
  if (!value) {
    return null
  }

  return (
    show && (
      <div
        className={classNames(styles.row, {
          [styles[type]]: !isCampaign,
          [styles.campaignAppraise]: isCampaign,
        })}
      >
        <Text fontSize={type === 'column' ? 'small' : 'medium'}>{label}</Text>
        <Text
          className={classNames(styles.value, { [styles.strike]: strike })}
          fontSize={type === 'column' ? 'medium' : 'regular'}
        >
          {`R$ ${value.toLocaleString('pt-br', { maximumFractionDigits: 0 })}`}
        </Text>
      </div>
    )
  )
}

export default React.memo(AprraisedValue)
